module.exports = __webpack_public_path__ + "static/media/Gemmer, Kelli square_1701944702852.198ddfe3.jpg";